import {css} from 'lit';

export const style = css`
    .tag-list__wrapper {
        display: flex;
        flex-wrap: wrap;
        margin: var(--sbkCoreGridSmMargin) 0;
        padding: 0;
        row-gap: var(--sbkCoreGridSmMargin);
    }

    ::slotted(sbk-tag) {
        margin-right: var(--sbkCoreSpacing3xs);
    }

    ::slotted(sbk-tag:last-child) {
        margin-right: 0;
    }
`
